import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { get } from '../../../services/back.service';
import ModalMessage from '../../../components/widgets/modalMessage';
import useFinishInspection from '../../../hooks/useFinishInspection';
import InspectionStepper from '../../components/inspection/InspectionStepper';
import FormScope from '../../../components/collaboration/FormScope';
import PresenceBar from '../../../components/collaboration/PresenceBar';

// Form imports from existing codebase
import FormAdditionalObs from '../../../components/forms/inspection/form.additionalObs';
import FormInfoBodywork from '../../../components/forms/inspection/form.bodywork';
import FormInfoChasis from '../../../components/forms/inspection/form.chassisStructure';
import FormClaims from '../../../components/forms/inspection/form.claims';
import FormFinalResult from '../../../components/forms/inspection/form.finalResult';
import FormInfoFluids from '../../../components/forms/inspection/form.fluids';
import FormGeneralInfo from '../../../components/forms/inspection/form.infoClient';
import FormInfoVehicle from '../../../components/forms/inspection/form.infoVehicle';
import FormMotorReport from '../../../components/forms/inspection/form.motorReport';
import FormInfoPaint from '../../../components/forms/inspection/form.paint';
import FormPropertyCard from '../../../components/forms/inspection/form.propertycard';
import FormInfoTires from '../../../components/forms/inspection/form.tires';
import FormVehiclePicture from '../../../components/forms/inspection/form.vehiclePicture';
import FormVehiclePicturePlus from '../../../components/forms/inspection/form.vehiclePicturePlus';
import FormSoatPicture from '../../../components/forms/inspection/form.vehiclePictureSoat';
import FormTechPicture from '../../../components/forms/inspection/form.vehiclePictureTec';
import FormAddObsComp from '../../../components/forms/inspection/vehicleComponentsForms/form.additionalObs';
import FormCompBottom from '../../../components/forms/inspection/vehicleComponentsForms/form.comp.bottomComp';
import FormCompCushions from '../../../components/forms/inspection/vehicleComponentsForms/form.comp.cushions';
import FormCompElectric from '../../../components/forms/inspection/vehicleComponentsForms/form.comp.electric';
import FormCompFluidLevels from '../../../components/forms/inspection/vehicleComponentsForms/form.comp.fluidLevels';
import FormCompFluids from '../../../components/forms/inspection/vehicleComponentsForms/form.comp.fluids';
import FormCompLights from '../../../components/forms/inspection/vehicleComponentsForms/form.comp.ligths';
import FormCompMotorComp from '../../../components/forms/inspection/vehicleComponentsForms/form.comp.motorComlement';
import FormInfoTiresMoto from '../../../components/forms/inspection/form.tiresMoto';
import FormCompFluidsMoto from '../../../components/forms/inspection/motoComponentsForms/form.comp.fluids';
import FormCompFluidLevelsMoto from '../../../components/forms/inspection/motoComponentsForms/form.comp.fluidLevels';
import FormCompCushionsMoto from '../../../components/forms/inspection/motoComponentsForms/form.comp.cushions';
import FormCompMotorCompMoto from '../../../components/forms/inspection/motoComponentsForms/form.comp.motorComlement';
import FormCompElectricMoto from '../../../components/forms/inspection/motoComponentsForms/form.comp.electric';
import FormCompLightsMoto from '../../../components/forms/inspection/motoComponentsForms/form.comp.ligths';
import FormCompBottomMoto from '../../../components/forms/inspection/motoComponentsForms/form.comp.bottomComp';
import FormVehiclePictureRecord from '../../../components/forms/inspection/form.vehiclePictureRecord';
import FormAccesories from '../../../components/forms/inspection/form.accesories';
import FormOwnerHistoryReport from '../../../components/forms/inspection/form.propertyReport';
import FormScannerSheetReport from '../../../components/forms/inspection/form.scannerReport';

import { FaArrowLeft, FaArrowRight, FaCheckCircle, FaListUl, FaLayerGroup } from 'react-icons/fa';

export default function WebCreateInspectionV2({ editid }) {
  const [id, setId] = useState(0);
  const [vehicleclass, setVehicleclass] = useState(0);
  const [avaibleForms, setAvaibleForms] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [viewMode, setViewMode] = useState('wizard'); // 'wizard' | 'all'

  const navigate = useNavigate();

  useEffect(() => {
    setId(editid);
  }, [editid]);

  const updateService = async (id_service) => {
    try {
      const respo = await get('/peritaje/forms/' + id_service);
      if (respo.success) setAvaibleForms(respo.data);
    } catch (err) {
      console.error('Error fetching available forms:', err);
    }
  };

  const validateHistoricPlate = async (plateId) => {
    try {
      const respo = await get('/peritaje/valid_history/' + plateId, {});
      if (respo.success && respo.data?.count > 0) {
        setShowModal(true);
      }
    } catch (err) {
      console.error('Error validating historic plate:', err);
    }
  };

  const goToReport = useCallback(() => navigate('/inspectionreport'), [navigate]);
  const { faltantes, finish: finishInspect, closeFaltantes } = useFinishInspection({
    inspectionId: id,
    onSuccess: goToReport,
  });

  const modalFunction = () => {
    setShowModal(false);
  };

  // Define categorized steps for progressive disclosure
  const steps = useMemo(() => [
    { id: 'general', title: '1. Datos & Vehículo', count: 1 + (avaibleForms[6] ? 1 : 0) + (avaibleForms[7] ? 1 : 0) + (avaibleForms[20] ? 1 : 0) + (avaibleForms[21] ? 1 : 0) },
    { id: 'structure', title: '2. Estructura & Carrocería', count: (avaibleForms[1] ? 1 : 0) + (avaibleForms[2] ? 1 : 0) + (avaibleForms[5] ? 1 : 0) },
    { id: 'mechanics', title: '3. Mecánica & Fluidos', count: (avaibleForms[3] ? 1 : 0) + (avaibleForms[4] ? 1 : 0) + (avaibleForms[17] ? 1 : 0) + (avaibleForms[11] ? 1 : 0) },
    { id: 'components', title: '4. Componentes & Eléctrico', count: (avaibleForms[9] ? 7 : 0) + (avaibleForms[18] ? 7 : 0) + (avaibleForms[19] ? 1 : 0) },
    { id: 'photos', title: '5. Fotografías & Documentos', count: (avaibleForms[8] ? 1 : 0) + (avaibleForms[13] ? 2 : 0) + (avaibleForms[15] ? 1 : 0) + (avaibleForms[16] ? 1 : 0) },
    { id: 'obs', title: '6. Novedades & Observaciones', count: (avaibleForms[10] ? 1 : 0) + (avaibleForms[14] ? 1 : 0) },
    { id: 'results', title: '7. Calificación & Cierre', count: (avaibleForms[12] ? 1 : 0) },
  ], [avaibleForms]);

  const isStepVisible = (stepIndex) => {
    if (viewMode === 'all') return true;
    return activeStep === stepIndex;
  };

  return (
    <div className="v2-inspection-container">
      {/* Top Action Bar with View Mode Toggle */}
      <div className="v2-card mb-3 p-3 v2-top-action-bar">
        <div className="v2-top-action-left">
          <span className="v2-badge v2-badge-danger">Inspección #{id || 'Nueva'}</span>
          <span className="text-muted small text-nowrap">
            {viewMode === 'wizard' ? `Paso ${activeStep + 1} de ${steps.length}` : 'Vista completa (todos los módulos)'}
          </span>
        </div>

        <div className="v2-top-action-right">
          {id !== 0 && <PresenceBar inspectionId={id} />}

          <div className="im-segmented-control flex-shrink-0">
            <button
              type="button"
              className={`im-segmented-btn ${viewMode === 'wizard' ? 'active' : ''}`}
              onClick={() => setViewMode('wizard')}
            >
              <FaLayerGroup size={12} className="me-1" />
              <span className="d-none d-sm-inline">Paso a Paso</span>
              <span className="d-inline d-sm-none">Pasos</span>
            </button>
            <button
              type="button"
              className={`im-segmented-btn ${viewMode === 'all' ? 'active' : ''}`}
              onClick={() => setViewMode('all')}
            >
              <FaListUl size={12} className="me-1" />
              <span className="d-none d-sm-inline">Ver Todo</span>
              <span className="d-inline d-sm-none">Todo</span>
            </button>
          </div>

          {id !== 0 && (
            <button
              type="button"
              className="v2-btn v2-btn-primary flex-shrink-0"
              onClick={finishInspect}
              title="Finalizar Peritaje"
            >
              <FaCheckCircle /> <span>Finalizar</span>
            </button>
          )}
        </div>
      </div>

      {/* Stepper Navigation */}
      {viewMode === 'wizard' && (
        <InspectionStepper
          steps={steps}
          activeStep={activeStep}
          onSelectStep={setActiveStep}
        />
      )}

      {/* Form Modules */}
      <div className="v2-inspection-body">
        {/* Step 1: General & Vehicle */}
        {isStepVisible(0) && (
          <div className="v2-card">
            <div className="v2-card-header">
              <h3>Información General y del Vehículo</h3>
            </div>
            <FormScope scope="principal:" label="los datos generales">
              <FormGeneralInfo
                id={id}
                updateId={setId}
                updateService={updateService}
                setVehicleclass={setVehicleclass}
                validateHistoricPlate={validateHistoricPlate}
              />
            </FormScope>
            {avaibleForms[6] && (
              <FormScope scope="pictures:PC" label="la cédula del vehículo">
                <FormPropertyCard id={id} />
              </FormScope>
            )}
            {avaibleForms[7] && (
              <FormScope scope="header:vehicle" label="la información del vehículo">
                <FormInfoVehicle id={id} />
              </FormScope>
            )}
            {avaibleForms[20] && (
              <FormScope scope="attach:OH" label="el historial del propietario">
                <FormOwnerHistoryReport id={id} />
              </FormScope>
            )}
            {avaibleForms[21] && (
              <FormScope scope="attach:SS" label="las hojas escaneadas">
                <FormScannerSheetReport id={id} />
              </FormScope>
            )}
          </div>
        )}

        {/* Step 2: Structure & Bodywork */}
        {isStepVisible(1) && (
          <div className="v2-card">
            <div className="v2-card-header">
              <h3>Estructura, Carrocería y Pintura</h3>
            </div>
            {avaibleForms[1] && (
              <FormScope scope="parts:C" label="la estructura (chasis)">
                <FormInfoChasis id={id} vehicleclass={vehicleclass} />
              </FormScope>
            )}
            {avaibleForms[2] && (
              <FormScope scope="parts:E" label="la carrocería">
                <FormInfoBodywork id={id} vehicleclass={vehicleclass} />
              </FormScope>
            )}
            {avaibleForms[5] && (
              <FormScope scope="paint:P" label="la pintura">
                <FormInfoPaint id={id} />
              </FormScope>
            )}
          </div>
        )}

        {/* Step 3: Mechanics, Fluids & Tires */}
        {isStepVisible(2) && (
          <div className="v2-card">
            <div className="v2-card-header">
              <h3>Mecánica, Fluidos y Llantas</h3>
            </div>
            {avaibleForms[3] && (
              <FormScope scope="fluids:F" label="los fluidos">
                <FormInfoFluids id={id} />
              </FormScope>
            )}
            {avaibleForms[4] && (
              <FormScope scope="tires:" label="las llantas">
                <FormInfoTires id={id} />
              </FormScope>
            )}
            {avaibleForms[17] && (
              <FormScope scope="tires:" label="las llantas (moto)">
                <FormInfoTiresMoto id={id} />
              </FormScope>
            )}
            {avaibleForms[11] && (
              <FormScope scope="attach:MR" label="el reporte de motor">
                <FormMotorReport id={id} />
              </FormScope>
            )}
          </div>
        )}

        {/* Step 4: Components & Electrical */}
        {isStepVisible(3) && (
          <div className="v2-card">
            <div className="v2-card-header">
              <h3>Componentes, Confort y Sistema Eléctrico</h3>
            </div>
            {avaibleForms[19] && (
              <FormScope scope="accesories:" label="los accesorios">
                <FormAccesories id={id} />
              </FormScope>
            )}
            {avaibleForms[9] && (
              <>
                <FormScope scope="components:FC" label="los fluidos de componentes">
                  <FormCompFluids id={id} />
                </FormScope>
                <FormScope scope="components:FL" label="los niveles de fluidos">
                  <FormCompFluidLevels id={id} />
                </FormScope>
                <FormScope scope="components:MC" label="el complemento del motor">
                  <FormCompMotorComp id={id} />
                </FormScope>
                <FormScope scope="components:BC" label="el montaje inferior">
                  <FormCompBottom id={id} />
                </FormScope>
                <FormScope scope="components:CC" label="los cojines">
                  <FormCompCushions id={id} />
                </FormScope>
                <FormScope scope="components:EC" label="el sistema eléctrico">
                  <FormCompElectric id={id} />
                </FormScope>
                <FormScope scope="components:LC" label="las luces">
                  <FormCompLights id={id} />
                </FormScope>
              </>
            )}
            {avaibleForms[18] && (
              <>
                <FormScope scope="components:FC" label="los fluidos (moto)">
                  <FormCompFluidsMoto id={id} />
                </FormScope>
                <FormScope scope="components:FL" label="los niveles de fluidos (moto)">
                  <FormCompFluidLevelsMoto id={id} />
                </FormScope>
                <FormScope scope="components:MC" label="el complemento del motor (moto)">
                  <FormCompMotorCompMoto id={id} />
                </FormScope>
                <FormScope scope="components:BC" label="el montaje inferior (moto)">
                  <FormCompBottomMoto id={id} />
                </FormScope>
                <FormScope scope="components:CC" label="los cojines (moto)">
                  <FormCompCushionsMoto id={id} />
                </FormScope>
                <FormScope scope="components:EC" label="el sistema eléctrico (moto)">
                  <FormCompElectricMoto id={id} />
                </FormScope>
                <FormScope scope="components:LC" label="las luces (moto)">
                  <FormCompLightsMoto id={id} />
                </FormScope>
              </>
            )}
            {(avaibleForms[9] || avaibleForms[18]) && (
              <FormScope scope="header:obsComp" label="las observaciones de componentes">
                <FormAddObsComp id={id} />
              </FormScope>
            )}
          </div>
        )}

        {/* Step 5: Photographs & Records */}
        {isStepVisible(4) && (
          <div className="v2-card">
            <div className="v2-card-header">
              <h3>Registro Fotográfico y Documentos</h3>
            </div>
            {avaibleForms[8] && (
              <FormScope scope="pictures:CI" label="las fotografías del vehículo">
                <FormVehiclePicture id={id} />
              </FormScope>
            )}
            {avaibleForms[13] && (
              <>
                <FormScope scope="pictures:AI" label="las fotografías adicionales">
                  <FormVehiclePicturePlus id={id} />
                </FormScope>
                <FormScope scope="pictures:RI" label="las fotografías de registro">
                  <FormVehiclePictureRecord id={id} />
                </FormScope>
              </>
            )}
            {avaibleForms[15] && (
              <FormScope scope="pictures:TM" label="la foto del SOAT">
                <FormSoatPicture id={id} />
              </FormScope>
            )}
            {avaibleForms[16] && (
              <FormScope scope="pictures:SO" label="la foto de la ficha técnica">
                <FormTechPicture id={id} />
              </FormScope>
            )}
          </div>
        )}

        {/* Step 6: Claims & Observations */}
        {isStepVisible(5) && (
          <div className="v2-card">
            <div className="v2-card-header">
              <h3>Reclamaciones y Observaciones Adicionales</h3>
            </div>
            {avaibleForms[10] && (
              <FormScope scope="claims:" label="las reclamaciones">
                <FormClaims id={id} />
              </FormScope>
            )}
            {avaibleForms[14] && (
              <FormScope scope="header:obs" label="las observaciones adicionales">
                <FormAdditionalObs id={id} />
              </FormScope>
            )}
          </div>
        )}

        {/* Step 7: Final Result & Finish */}
        {isStepVisible(6) && (
          <div className="v2-card">
            <div className="v2-card-header">
              <h3>Calificación y Cierre de Peritaje</h3>
            </div>
            {avaibleForms[12] && (
              <FormScope scope="header:result" label="la calificación final">
                <FormFinalResult id={id} />
              </FormScope>
            )}
            {id !== 0 && (
              <div className="mt-4 p-3 bg-light rounded text-center">
                <p className="mb-3 text-muted">
                  Asegúrese de haber completado todos los campos requeridos antes de finalizar.
                </p>
                <button
                  type="button"
                  onClick={finishInspect}
                  className="v2-btn v2-btn-primary px-4 px-sm-5 py-2 fs-6 w-100 w-sm-auto"
                >
                  <FaCheckCircle className="me-2" /> Finalizar Peritaje
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Step Navigation Controls (Wizard mode only) */}
      {viewMode === 'wizard' && (
        <div className="v2-card v2-inspection-bottom-bar p-3 d-flex justify-content-between align-items-center gap-2">
          <button
            type="button"
            className="v2-btn v2-btn-secondary"
            disabled={activeStep === 0}
            onClick={() => {
              setActiveStep((prev) => Math.max(0, prev - 1));
              if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
          >
            <FaArrowLeft /> <span className="d-none d-sm-inline">Anterior</span>
          </button>

          <span className="text-muted small fw-bold text-nowrap">
            Paso {activeStep + 1} de {steps.length}
          </span>

          {activeStep < steps.length - 1 ? (
            <button
              type="button"
              className="v2-btn v2-btn-primary"
              onClick={() => {
                setActiveStep((prev) => Math.min(steps.length - 1, prev + 1));
                if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }}
            >
              <span className="d-none d-sm-inline">Siguiente</span> <FaArrowRight />
            </button>
          ) : id !== 0 ? (
            <button
              type="button"
              className="v2-btn v2-btn-primary"
              onClick={finishInspect}
            >
              <FaCheckCircle /> <span className="d-none d-sm-inline">Finalizar Peritaje</span><span className="d-inline d-sm-none">Finalizar</span>
            </button>
          ) : (
            <span className="text-muted small text-end">Guarde datos generales</span>
          )}
        </div>
      )}

      {/* Historic plate modal */}
      <ModalMessage
        title="Advertencia"
        text="Esta placa tiene un peritaje en el historial, por favor revisar"
        showProps={showModal}
        funcAccept={modalFunction}
        funcClose={modalFunction}
      />

      {/* Faltantes detectados al intentar cerrar el peritaje */}
      <ModalMessage
        title="Faltantes del peritaje"
        text={faltantes || ''}
        showProps={!!faltantes}
        funcAccept={closeFaltantes}
        funcClose={closeFaltantes}
      />
    </div>
  );
}
